import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="activity-indicator"
export default class extends Controller {
  static targets = [ "activity", "action"]

  show() {
    this.activityTarget.classList.remove("hidden")
    this.actionTarget.classList.add("hidden")
  }

  hide() {
    this.activityTarget.classList.add("hidden")
    this.actionTarget.classList.remove("hidden")
  }
}
